import * as React from 'react';
import {
  RightMenuPanelContainer,
  ListContainer,
  LiContainer,
  LinkStyle,
  SubMenuList,
  SubMenuListItem,
  SubMenuAnchor,
} from './rightMenuPanelStyle';
import isExternalUrl, {
  addTrailingSlash,
  isExternalUrlhref,
} from '../../../utils';

const RightMenuPanel = (props) => {
  const [showSubMenu, setShowSubMenu] = React.useState();
  const [isHovering, setIsHovering] = React.useState(false);

  const onHover = (e, index) => {
    setShowSubMenu(index);
  };
  const handleHoverEnter = () => {
    setIsHovering(true);
  };
  const handleHoverLeave = () => {
    setIsHovering(false);
  }
  return (
    <RightMenuPanelContainer>
      <ListContainer>
        {props?.menu?.map((item, index) => {
          return (
            <LiContainer key={index} onMouseEnter={(e) => onHover(e, index)}>
                <LinkStyle
                  href={
                    item?.textWithPath?.path
                      ? isExternalUrlhref(item?.textWithPath?.path)
                        ? item?.textWithPath?.path
                        : addTrailingSlash(
                            process.env.GATSBY_DOMAIN_URL +
                              item?.textWithPath?.path
                          )
                      : '/'
                  }
                  target={
                    isExternalUrl(item?.textWithPath?.path) ? '_blank' : '_self'
                  }
                  onMouseEnter={index == 2 ? handleHoverEnter : null}
                >
                  {item?.textWithPath?.text}
                </LinkStyle>

                {isHovering && index === 2 && props.menu[2].type === 'products/services' && (
                  <div onMouseLeave={handleHoverLeave}>
                    <SubMenuListItem>
                      <SubMenuAnchor href={process.env.GATSBY_DOMAIN_URL + item?.textWithPath?.path + '#title'}>
                        Techron
                      </SubMenuAnchor>
                    </SubMenuListItem>
                    <SubMenuListItem>
                      <SubMenuAnchor href={process.env.GATSBY_DOMAIN_URL + item?.textWithPath?.path + 'carwash'}>
                        Car Wash
                      </SubMenuAnchor>
                    </SubMenuListItem>
                  </div>
                )}
                
              {showSubMenu === index &&
              item?.subMenusWithPaths &&
              item?.subMenusWithPaths?.length ? (
                <SubMenuList>
                  {item?.subMenusWithPaths?.map((children, index) => {
                    return (
                      <SubMenuListItem key={index}>
                        <SubMenuAnchor
                          href={
                            isExternalUrlhref(
                              children?.path ??
                                children?.textWithPath?.path ??
                                item.path
                            )
                              ? children?.path ??
                                children?.textWithPath?.path ??
                                item.path
                              : addTrailingSlash(
                                  process.env.GATSBY_DOMAIN_URL +
                                    (children?.path ??
                                      children?.textWithPath?.path ??
                                      item.path)
                                )
                          }
                          target={
                            isExternalUrl(
                              children.path ??
                                children?.textWithPath?.path ??
                                item.path
                            )
                              ? '_blank'
                              : '_self'
                          }
                        >
                          {children?.text ?? children?.textWithPath?.text ?? ''}
                        </SubMenuAnchor>
                      </SubMenuListItem>
                    );
                  })}
                </SubMenuList>
              ) : null}
            </LiContainer>
          );
        })}
      </ListContainer>
    </RightMenuPanelContainer>
  );
};

export default RightMenuPanel;
